export default __webpack_public_path__ + "static/media/star.a3b51c8b.svg";